// autogenerated
import {AthenaeumConstants, ServiceProvider} from "@reapptor-apps/reapptor-toolkit";
import {TicketType} from "@/models/Enums";
import ShuttleTicketPrice from "@/models/server/shuttle/ShuttleTicketPrice";
import Waypoint from "@/models/server/bout/Waypoint";

export default class ShuttleWaypoint extends Waypoint {

    public shuttleId: string = "";

    public ticketTypes: TicketType[] = [];

    public ticketPrices: ShuttleTicketPrice[] | null = null;

    public maxTickets: number | null = null;

    public readonly isShuttleWaypoint: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof ShuttleWaypoint) || ((from as any).isShuttleWaypoint === true));
    }

    public static as(from?: object | null): ShuttleWaypoint | null {
        return (ShuttleWaypoint.is(from)) ? from as ShuttleWaypoint : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(ShuttleWaypoint, "ShuttleWaypoint");